
export function suppressMsalLogs() {
  const originalGroupCollapsed = console.groupCollapsed;
  const originalTrace = console.trace;
  const originalCount = console.count;

  let ignoreNextTrace = false;

  function isMsalMessage(args) {
    return args.some(
      (arg) =>
        typeof arg === "string" &&
        arg.includes("[use-msal] acquireToken: Silent failed")
    );
  }

  console.groupCollapsed = function (...args) {
    if (isMsalMessage(args)) {
      ignoreNextTrace = true;
      return;
    }
    originalGroupCollapsed.apply(console, args);
  };

  console.trace = function (...args) {
    if (ignoreNextTrace) {
      ignoreNextTrace = false;
      return;
    }
    originalTrace.apply(console, args);
  };

  console.count = function (...args) {
    if (ignoreNextTrace) return;
    originalCount.apply(console, args);
  };
}
